module.exports = __webpack_public_path__ + "static/media/Subtract.da53e673.svg";